import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { BaseService } from './base.service';
import { LoadingService } from './loading.service';
import { Tenant } from '../models/domain/Tenant';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService extends BaseService<Tenant> {
  private readonly rowCountSubject: BehaviorSubject<number>;
  public readonly rowCount$: Observable<number>;
  private http: HttpClient;

  constructor(http: HttpClient, loadingService: LoadingService,
    public authService: AuthenticationService
  ) {
    super(http, `${environment.apiUrl}/v1/tenant`, loadingService);
    this.http = http;
    this.rowCountSubject = new BehaviorSubject<number>(0);
    this.rowCount$ = this.rowCountSubject.asObservable();
  }

  public GetTenantByClientIdAsync(): Observable<HttpResponse<Tenant[]>> {
    this.loadingService.showLoading();

    return this.httpClient.get<Tenant[]>(`${this.baseApiUrl}/${this.authService.getCurrentUser()?.clientId}/tenants`, { observe: "response" })
      .pipe(tap(response => {
        this.loadingService.hideLoading();
      }),
        catchError(error => {
          // Propagate the error properly to the ErrorInterceptor
          this.loadingService.hideLoading();
          return throwError(() => error); // Make sure to throw the error properly
        })
      );
  }
}